import React from 'react';
import { Handle, Position } from 'reactflow';
import Button from '../../../../components/Button/Button';

interface DefaultButtonProps {
  handleId: string;
  onClick?: (event: React.MouseEvent) => void;
  isConnectable: boolean;
  isClickable?: boolean;
  isHighlighted?: boolean;
}

function DefaultButton({
  handleId,
  onClick,
  isConnectable,
  isClickable = false,
  isHighlighted = false
}: Readonly<DefaultButtonProps>): React.ReactElement {
  const highlightClass = isHighlighted
    ? 'ring-2 ring-blue-500 shadow-[0_0_10px_rgba(59,130,246,0.5)]'
    : '';

  const content = isClickable ? (
    <Button
      variant='outline'
      className={`p-3 border rounded-md bg-gray-100 opacity-70 cursor-pointer text-sm w-full justify-start text-left ${highlightClass}`}
      onClick={onClick}
    >
      Default
    </Button>
  ) : (
    <div
      className={`p-3 border rounded-md bg-gray-100 opacity-70 text-sm ${highlightClass}`}
    >
      Default
    </div>
  );

  return (
    <div className='mb-2 relative'>
      {content}
      <Handle
        type='source'
        position={Position.Right}
        id={handleId}
        className={
          isClickable ? undefined : 'w-3 h-3 bg-blue-500 border-2 border-white'
        }
        style={{ right: -26 }}
        isConnectable={isConnectable}
      />
    </div>
  );
}

export default DefaultButton;
